/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// Keep YMM brand labels consistent without changing the app's lookup values.
(() => {
  const selector = 'select.ymm-filter option[value="mk_kawasaki"], select.ymm-filter option[value="mk_yamaha"]';
  const labels = { mk_kawasaki: 'KAWASAKI', mk_yamaha: 'YAMAHA' };
  function normalize(root) {
    if (!root || root.nodeType !== 1) return;
    const options = root.matches(selector) ? [root] : root.querySelectorAll(selector);
    options.forEach(option => {
      const label = labels[option.value];
      if (option.textContent !== label) option.textContent = label;
    });
  }
  function start() {
    normalize(document.body);
    new MutationObserver(records => {
      records.forEach(record => {
        normalize(record.target);
        record.addedNodes.forEach(normalize);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();


// Suzuki GSXR600/750 K4/K5 shares one collection and one visible year choice.
(() => {
  const destination = '/collections/suzuki-gsxr600-gsxr750-2004-2005-fairings';
  function fields() {
    return {
      brand: document.querySelector('select.ymm-filter[id="dropdown-field_2"]'),
      model: document.querySelector('select.ymm-filter[id="dropdown-field_3"]'),
      year: document.querySelector('select.ymm-filter[id="dropdown-field_1"]')
    };
  }
  function isSuzuki(f) {
    return f.brand?.value === 'mk_suzuki' && f.model?.value === 'md_gsxr600-750';
  }
  function combine() {
    const f = fields();
    if (!isSuzuki(f) || !f.year) return;
    const first = f.year.querySelector('option[value="yr_2004"]');
    const second = f.year.querySelector('option[value="yr_2005"]');
    if (!first) return;
    if (first.textContent !== '2004\u20132005') first.textContent = '2004\u20132005';
    if (second) {
      const selected = second.selected;
      second.remove();
      if (selected) {
        f.year.value = first.value;
        f.year.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  function route(event) {
    if (!event.target.closest('#ymm_search')) return;
    const f = fields();
    if (!isSuzuki(f) || !['yr_2004', 'yr_2005'].includes(f.year?.value)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(destination);
  }
  function start() {
    combine();
    document.addEventListener('click', route, true);
    document.addEventListener('change', combine);
    new MutationObserver(records => {
      if (records.some(r => r.target.closest?.('#ymm_searchbox') ||
        Array.from(r.addedNodes).some(n => n.nodeType === 1 && (n.matches('#ymm_searchbox') || n.querySelector('#ymm_searchbox'))))) combine();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
